import { render, staticRenderFns } from "./ModalRegisterRbmAgent.vue?vue&type=template&id=3aad1891&"
import script from "./ModalRegisterRbmAgent.vue?vue&type=script&lang=js&"
export * from "./ModalRegisterRbmAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports